var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "box", attrs: { fluid: "" } },
    [
      _c("v-layout", { staticClass: "title" }, [_vm._v("TRANSFERÊNCIAS")]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-space-around": "", wrap: "" } },
        [
          _c("Wallet", {
            attrs: { label: "de" },
            on: { selected: _vm.setPayer }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-to" }, [
            _c("div", { staticClass: "arrow" }, [_vm._v(">")]),
            _vm._v("\n      transferir "),
            _c("br"),
            _vm._v("para\n    ")
          ]),
          _vm._v(" "),
          _c("Wallet", {
            attrs: { label: "para" },
            on: { selected: _vm.setReceiver }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "", "align-center": "", "justify-center": "" } },
        [
          _c("v-layout", { staticClass: "title", attrs: { row: "" } }, [
            _vm._v("Valor a ser transferido")
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c("Currency", {
                attrs: { label: "" },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c("v-textarea", {
                attrs: {
                  outlined: "",
                  color: "primary",
                  label: "descrição",
                  rows: "5"
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "submit-transfer",
              attrs: { row: "", "justify-space-around": "" }
            },
            [
              _vm.completedTransfer
                ? _c(
                    "v-layout",
                    { staticClass: "icon-wallet" },
                    [
                      _c("v-flex", { attrs: { md3: "" } }, [
                        _c("img", { attrs: { src: _vm.transferResultImage } })
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { md9: "" } }, [
                        _c("p", { staticClass: "success-message" }, [
                          _vm._v(_vm._s(_vm.transferResultMessage))
                        ])
                      ])
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        rounded: "",
                        color: "primary",
                        loading: _vm.preloader,
                        dark: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [_vm._v("transferir")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67200947", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67200947","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfers/NewTransfer/Index.vue
// module id = null
// module chunks = 